export default (docId, fieldId) => `${docId}/${fieldId}`;
